/**
 * Client ID Management
 * Generates and persists anonymous user identifier across sessions
 */

const CLIENT_ID_KEY = 'floorplan_client_id';

/**
 * Generate a unique client ID using UUID v4 format
 * @returns {string} UUID in format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Get or create client ID
 * Returns the persistent client ID for this browser/device
 * @returns {string|null} Client ID or null if localStorage is unavailable
 */
export function getClientId() {
  try {
    let clientId = localStorage.getItem(CLIENT_ID_KEY);

    if (!clientId) {
      clientId = generateUUID();
      localStorage.setItem(CLIENT_ID_KEY, clientId);
      console.log('New client ID generated:', clientId);
    }

    return clientId;
  } catch (error) {
    // localStorage might be unavailable (private mode, disabled, etc.)
    console.warn('Failed to access localStorage for clientId:', error);
    console.warn('Conversion tracking will not work for this session');
    return null;
  }
}

/**
 * Clear client ID (used for testing or privacy cleanup)
 */
export function clearClientId() {
  try {
    localStorage.removeItem(CLIENT_ID_KEY);
    console.log('Client ID cleared');
  } catch (error) {
    console.warn('Failed to clear clientId from localStorage:', error);
  }
}
